<template>
  <div v-if="versions.length > 1" class="my-4">
    <v-note
      connotation="information"
      icon="megaphone-solid"
      :headline="$t('documentation.api.thereAreMultipleVersions')"
    >
      <div class="flex gap-2 mt-2">
        <div v-for="info in versions" :key="info.version" :property="info.version">
          <b v-if="info.current">{{ $t('documentation.api.version') }} {{ info.version }}</b>
          <link-wrapper v-else :href="info.link">{{ $t('documentation.api.version') }} {{ info.version }}</link-wrapper>
        </div>
      </div>
    </v-note>
  </div>
</template>

<script setup lang="ts">
import { PropType } from 'vue';
import { Versions } from '@bifrost-dev-docs-mfe/common/types/apiDocs';
import { VNote } from '@vonage/vivid-vue';
import LinkWrapper from '@/components/markdown/widgets/LinkWrapper.vue';

defineProps({
  versions: { type: Array as PropType<Versions>, required: true },
});
</script>

<style scoped lang="scss">
b {
  font-weight: 600;
}
</style>
